import React from "react";
import { graphql, QueryRenderer } from "react-relay";
import environment from "./Environment";
import { GC_USER_ID } from "./constants";
import AddSourceContainer from "./AddSourceContainer";
import { createOperationDescriptor, getRequest } from "relay-runtime";
import ThemeProvider from "./contexts/ThemeContext";
import Spinner from "./Spinner";

const userDetailsQuery = graphql`
    query AddSourceContainerWrapper_UserDetails_Query($id: ID!) {
        user(id: $id) {
            email
            is_premium
            is_active
            first_time_user
        }
        settings {
            isAuthenticated
            userId
            isNavActivated
            selectedSourceId
            selectedParentId
            treeStates
            selectedNodeId
            isParent
            isFullScreenAddSourceModalActivated
            isAddSourceModalActivated

            selectedSubId
            selectedSubName

            sourceString
            categoryId
        }
    }
`;

const request = getRequest(userDetailsQuery);
const operation = createOperationDescriptor(request, {} /* variables */);

function AddSourceContainerWrapper(props) {
    let userId = localStorage.getItem(GC_USER_ID);

    return (
        <QueryRenderer
            environment={environment}
            query={userDetailsQuery}
            variables={{ id: userId }}
            render={({ error, props }) => {
                if (error) throw error;
                if (!props)
                    return (
                        <div>
                            <Spinner isLoading={true} />
                        </div>
                    );
                return (
                    <div>
                        <ThemeProvider>
                            <AddSourceContainer
                                user={props.user}
                                settings={props.settings}
                            />
                        </ThemeProvider>
                    </div>
                );
            }}
        />
    );
}

export default AddSourceContainerWrapper;
